import { z } from "zod";

export const POST_STATUS = ["bozza", "pubblicato", "archiviato"] as const;
export type PostStatus = (typeof POST_STATUS)[number];

const I18n = z.record(z.string());

export const PostCreateInput = z.object({
  slug: z.string().min(2).max(140).regex(/^[a-z0-9-]+$/, "slug kebab-case ASCII"),
  title: I18n.optional(),
});
export type PostCreateInput = z.infer<typeof PostCreateInput>;

export const PostPatchInput = z.object({
  status: z.enum(POST_STATUS).optional(),
  title: I18n.optional(),
  excerpt: I18n.optional(),
  body: I18n.optional(),
  cover_url: z.string().nullable().optional(),
  category: z.string().max(80).nullable().optional(),
  tags: z.array(z.string().max(40)).max(12).optional(),
  author: z.string().max(120).nullable().optional(),
});
export type PostPatchInput = z.infer<typeof PostPatchInput>;
